import { ConfigurationStepForm } from '../../../schemas/configurationStepSchema';
import { Program, ProgramFeatureName } from '../../../types/program';

const calculateDurationMeasure = (totalDurationInDays: number): number => {
  if (totalDurationInDays < 1) {
    return 1;
  } else if (totalDurationInDays > 7 && totalDurationInDays <= 30) {
    return 7;
  } else if (totalDurationInDays > 30) {
    return 30;
  }
  return 1;
};

const getTotalNumberOfClasses = (modules: Program['modules']) => {
  return modules.reduce((acc, module) => acc + module.contents.length, 0);
};

export const formatConfigurationStepValues = (
  program: Program
): ConfigurationStepForm => {
  const durationMeasure = calculateDurationMeasure(program.totalDurationInDays);

  const totalDurationInDays = Math.round(
    program.totalDurationInDays / durationMeasure
  );

  return {
    averageContentTimeInMinutes: program.averageContentTimeInMinutes ?? 0,
    totalDurationInDays,
    durationMeasure,
    numberOfClasses: getTotalNumberOfClasses(program.modules),
    objectiveId: program.objectives[0]?.id ?? 0,
    categoryId: program.categories[0]?.id ?? 0,
    levelId: program.levels[0]?.id ?? undefined,
    modalityIds: program.modalities.map(modality => modality.id),
    tags: program.tags,
    accessory: program.features.find(
      feature => feature.name === ProgramFeatureName.HasAccessory
    )?.value as boolean,
    gender: program.features.find(
      feature => feature.name === ProgramFeatureName.Gender
    )?.value as string[],
    forMothers: String(
      program.features.find(
        feature => feature.name === ProgramFeatureName.ForMother
      )?.value || ''
    ),
    durationValue: String(
      program.features.find(
        feature => feature.name === ProgramFeatureName.DurationProgram
      )?.value || ''
    ),
    isRecommendQuiz: Boolean(
      program.features.find(
        feature => feature.name === ProgramFeatureName.IsRecommendQuiz
      )?.value || false
    ),
    trainingDaysAvailable: Number(
      program.features.find(
        feature => feature.name === ProgramFeatureName.TrainingDaysAvailable
      )?.value || 0
    ),
    showInSearch: Boolean(
      program.features.find(
        feature => feature.name === ProgramFeatureName.ShowInSearch
      )?.value || false
    ),
  };
};
